module.exports = __webpack_public_path__ + "static/media/print-icon.9888ecf0.png";